export default __webpack_public_path__ + "static/media/Background.e583f3d4.png";